






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Card extends Vue {
    @Prop({default: 422, type: Number}) height: number;
    @Prop({default: 412, type: Number}) width: number;
}
